import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";
import dataHandler from "@Utils/dataHandler";
import FilterModal from "./Modals/FilterModal";
import ChatTagsTable from "./Components/ChatTagsTable";

import styles from "./styles.module.css";

const ChatTagsReport = ({ dispatch, userName, companyName }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [showTable, setShowTable] = useState(false);
	const [isOpenModal, setIsOpenModal] = useState(true);
	const [appliedFilters, setAppliedFilters] = useState({});
	const [hasResults, setHasResults] = useState(null);

	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "/reports/chattags/detailed", params });
		if (!printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setHasResults(data.count > 0);
		}
		if (printable) {
			setFilteredPrintData(data.items);
		}
	};

	const handleFilterData = () => {
		setIsOpenModal(true);
	};

	const renderTopButtons = () => {
		return [
			{
				icon: "filter",
				className: styles.refreshButton,
				onClick: handleFilterData,
				content: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
				label: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
			},
		];
	};

	const handleApplyFilters = (filters) => {
		setShowTable(true);
		setHasResults(null);
		setAppliedFilters(filters);
		setIsOpenModal(false);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Reporte Notas">
			{!showTable && (
				<div className={styles.grid}>
					<IkTable
						data={filteredItems}
						totalRows={filteredCount}
						dataHandler={handlerData}
						filteredPrintData={filteredPrintData}
						searcher={{
							searchable: false,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
					/>
				</div>
			)}
			{showTable && hasResults && (
				<ChatTagsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
					onDataCount={(count) => {
						return setHasResults(count > 0);
					}}
				/>
			)}
			{showTable && hasResults === false && (
				<div className={styles.noDataContainer}>
					<button type="button" className={styles.filterButton} onClick={handleFilterData}>
						Filtrar
					</button>
				</div>
			)}
			{isOpenModal && (
				<FilterModal
					dispatch={dispatch}
					onClose={() => {
						setIsOpenModal(false);
					}}
					onApplyFilters={handleApplyFilters}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
	};
}

ChatTagsReport.propTypes = {
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	companyName: PropTypes.string,
};

export default connect(mapStateToProps)(ChatTagsReport);
